module.exports = __webpack_public_path__ + "img/icon-shopping-bag.20bff8cf.svg";